var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlame = function SvgFlame(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 278 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.07 165.278C47.3025 86.7188 93.219 31.4657 179.328 0C126.602 68.3813 224.28 142.454 229.673 213.455C242.297 191.925 249.468 163.2 250.884 124.779C315.45 226.011 261.911 391.469 119.823 367.681C106.777 365.514 94.2133 361.388 82.7643 355.246C30.9424 327.604 0 267.353 0 209.811C0 173.136 15.6972 140.406 36.0041 114.39C38.7157 139.864 44.5005 158.864 56.07 165.278Z",
    fill: "#D7D8EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.048 278.765C87.4054 240.976 89.4241 179.942 130.43 158.533C130.731 228.691 199.877 237.634 187.072 312.519C198.883 299.15 204.848 277.771 205.903 260.879C224.643 303.757 209.94 338.053 183.216 355.517C101.958 408.633 31.9982 300.957 78.5174 241.94C79.9334 255.128 96.0826 275.483 102.048 278.765Z",
    fill: "#E2E5FE"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlame);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flame.87a4b844be9edb9d31ae719bc6a21c82.svg";